import { createTheme } from '@mui/material/styles';
import { breakpointsModel, defaultLightColors, ThemeColors } from "../core/types/ThemeModel";
import { ThemeName } from "./themes";

export const getMuiTheme = (mode: ThemeName, colors: ThemeColors | null) => {  

  const active = colors || defaultLightColors;

  return createTheme({
    typography: {
      fontFamily: 'Montserrat, sans-serif',
      h1: { 
        fontWeight: 700,
        fontSize: '80px' 
      },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { 
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 300,
        fontSize: '15px' 
      },
      subtitle1: {},
      subtitle2: {},
      body1: { fontSize: '1rem' },
      button: { 
        fontSize: '15px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 500,
        textTransform: 'uppercase',        
       },
      caption: {},

    },
    palette: {
      mode,
      primary: { main: active.primary },
      background: { default: active.white },
      
      text: {  
        primary: active.text,
        secondary: '#666',
        disabled: '#999',
      },    
    },
    breakpoints: {
      values: breakpointsModel,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: active.white,
            borderRadius: '100px',
            boxShadow: '0px 2px 10px rgba(30, 41, 71, 0.14)',
            maxWidth:'400px',
            width: '100%',
            height: '100%',
            fontSize: '15px', // 🔹 Aplica directamente
            fontFamily: 'Poppins, sans-serif', // 🔹 Aplica directamente
            fontWeight: 500,
            textTransform: 'uppercase',
            cursor: 'pointer',
            border: 'none',
            '&:hover': {
              backgroundColor: active.secondary ?? '#FCA422', // usa un color más oscuro si tienes uno
              color: active.white,
              shadows: "0px 2px 10px 0px rgba(30, 41, 71, 0.14)"
            },
          },
          outlined: {
            border: `1px solid ${active.primary}`,
            backgroundColor: 'transparent',
            color: active.primary,
            
            '&:hover': {
              border: `1px solid ${active.Activo ?? '#79DD8B'}`,
              backgroundColor: active.Activo ?? '#79DD8B',
              color: active.white,
            },
          },
        },        
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            fontSize: '18px',
            textTransform: 'none',
             "&.Mui-selected": {
              color: active.Activo,             
            },
            "&:not(.Mui-selected)": {
              color: active.Activo,
            },           
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            wordWrap: 'break-word',
            whiteSpace: 'normal', // para permitir saltos
            overflowWrap: 'break-word', // estándar moderno
          },
        },
      },
    },
  });
}; 